
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M1.833 3.306a.917.917 0 01.917-.917h16.5a.917.917 0 110 1.833v10.084a.917.917 0 01-.917.916h-4.228l1.431 4.294a.917.917 0 11-1.74.58l-1.623-4.874H9.828l-1.624 4.873a.917.917 0 11-1.74-.58l1.431-4.293H3.667a.917.917 0 01-.917-.916V4.222a.917.917 0 01-.917-.916zm13.75 3.666a.917.917 0 00-1.833 0v3.667a.917.917 0 001.833 0V6.972zm-3.666 1.834a.917.917 0 00-1.834 0v1.833a.917.917 0 101.834 0V8.806zm-4.584.916a.917.917 0 000 1.834h.01a.917.917 0 000-1.834h-.01z"}})])
          )
        }
      }
    